import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "../lib/ui";

const MANIFESTO_BG =
  "https://images.unsplash.com/photo-1606767041004-6b918abe92be?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

const CHAPTERS = [
  {
    n: "01",
    title: "Curated, Not Compromised",
    body: "We don't cut corners. Every compound is hand-selected from vetted synthesis partners and screened before it earns a place in the collection.",
  },
  {
    n: "02",
    title: "Purity You Can Read",
    body: "Every lot is third-party assayed by reverse-phase HPLC and confirmed by mass spectrometry. The numbers ride along on a Certificate of Analysis you can actually inspect.",
  },
  {
    n: "03",
    title: "Southern Service",
    body: "Discreet packaging, quick shipping, and a real person on the other end. Southern hospitality means honoring the order and standing behind the science. For research use only — always.",
  },
];

export const Manifesto = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="manifesto" ref={ref} data-testid="manifesto" className="relative scroll-mt-32 overflow-hidden bg-surface-dark px-6 py-28 text-cream md:px-12 md:py-40">
      <motion.div style={{ y }} className="pointer-events-none absolute inset-0 z-0">
        <img src={MANIFESTO_BG} alt="" className="h-full w-full object-cover opacity-20" />
        <div className="absolute inset-0 bg-surface-dark/50" />
      </motion.div>

      <div className="relative z-10 mx-auto max-w-[1500px]">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.35em] text-rust">[ The Method ]</p>
          <h2 className="mt-6 max-w-4xl font-display text-5xl leading-[0.9] tracking-tighter md:text-8xl">
            Held to a higher standard.
          </h2>
        </Reveal>

        <div className="mt-24 space-y-px">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.08}>
              <div className="grid grid-cols-1 items-start gap-6 border-t border-cream/15 py-12 md:grid-cols-[auto_1fr_2fr] md:gap-16">
                <span className="font-display text-7xl leading-none text-rust md:text-8xl">{c.n}</span>
                <h3 className="font-display text-3xl leading-tight tracking-tight md:text-4xl">{c.title}</h3>
                <p className="max-w-xl font-body text-base leading-relaxed text-cream/70 md:text-lg">{c.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
